import React, { useState } from 'react';
import ReliquidationBalancesTable from './ReliquidationBalancesTable';
import ReliquidationBalances from './ReliquidationBalances';

const componentMap = {
  ReliquidationBalancesTable,
  ReliquidationBalances
};

const ReliquidationProcessBalances = ({ onlyShow = false }) => {
  const [activeComponent, setActiveComponent] = useState('ReliquidationBalancesTable');
  const ActiveComponent = componentMap[activeComponent];

  return <>{ActiveComponent && <ActiveComponent setActiveComponent={setActiveComponent} onlyShow={onlyShow} />}</>;
};

export default ReliquidationProcessBalances;
